"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InlineError_1 = require("./InlineError");
exports.default = InlineError_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InlineError/index.js
// module id = 1710
// module chunks = 8